export default function About() {
  const features = [
    {
      icon: 'ri-timer-flash-line',
      title: 'Same Day Service',
      description: 'Fast response times for urgent cleanouts',
      color: 'from-cyan-500 to-blue-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Professional service you can trust',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Customer Focused',
      description: 'Your satisfaction is our priority',
      color: 'from-cyan-400 to-cyan-600'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(6, 182, 212, 0.3) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient Orb */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-flex items-center gap-2 text-cyan-400 text-sm font-bold tracking-[0.3em] uppercase mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              <span className="w-8 h-px bg-cyan-400"></span>
              About Us
            </span>
            
            <h2 
              className="text-4xl md:text-5xl font-black text-white mb-6"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              MEET THE <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">OWNER</span>
            </h2>

            <div className="space-y-6">
              <div className="bg-gray-800/30 border border-gray-700 rounded-lg p-6">
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  Carlos Maya
                </h3>
                <p className="text-cyan-400 font-medium mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  Founder &amp; Lead Operator
                </p>
                <p className="text-gray-400 leading-relaxed">
                  Carlos Maya brings years of experience and dedication to every job. Based in Riverside County, 
                  Carlos built HAUL IT ALL on the principles of reliability, professionalism, and customer satisfaction.
                </p>
              </div>

              <p className="text-gray-400 leading-relaxed">
                Whether it&apos;s a small furniture removal or a complete estate cleanout, Carlos treats every project 
                with the same level of care and attention to detail. His commitment to being loyal and professional 
                has earned him a reputation as the go-to hauling service in the area.
              </p>

              <p className="text-white font-semibold text-lg" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                No job is too big or too small. We&apos;re ready to help you reclaim your space.
              </p>

              <a
                href="tel:9513509072"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-md text-lg font-bold tracking-wider hover:from-cyan-400 hover:to-blue-500 transition-all duration-300 shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
              >
                <i className="ri-phone-fill"></i>
                Call Carlos: (951) 350-9072
              </a>
            </div>
          </div>

          {/* Right Content - Features */}
          <div className="space-y-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-gray-800/30 border border-gray-700 hover:border-cyan-500/50 rounded-lg p-6 transition-all duration-500 cursor-pointer"
              >
                <div className="flex items-start gap-5">
                  <div className={`w-16 h-16 rounded-lg bg-gradient-to-r ${feature.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-500 shadow-lg`}>
                    <i className={`${feature.icon} text-3xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                      {feature.title}
                    </h3>
                    <p className="text-gray-400">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {/* Trust Badge */}
            <div className="bg-gradient-to-r from-cyan-500/10 to-blue-600/10 border border-cyan-500/30 rounded-lg p-6 text-center">
              <div className="flex justify-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-cyan-400 text-xl"></i>
                ))}
              </div>
              <p className="text-white font-bold text-lg" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                Trusted by 500+ Customers
              </p>
              <p className="text-gray-400 text-sm">
                Serving Riverside County with excellence
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}